export default "__VITE_ASSET__BGy9QXMs__"